export default __webpack_public_path__ + "static/media/flexline_logo.4604442d.png";